import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.66667 1.66667C7.1269 1.66667 7.5 2.03977 7.5 2.50001V3.33334H12.5V2.50001C12.5 2.03977 12.8731 1.66667 13.3333 1.66667C13.7936 1.66667 14.1667 2.03977 14.1667 2.50001V3.33334H15C16.3807 3.33334 17.5 4.45263 17.5 5.83334V15C17.5 16.3807 16.3807 17.5 15 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V5.83334C2.5 4.45263 3.61929 3.33334 5 3.33334H5.83333V2.50001C5.83333 2.03977 6.20643 1.66667 6.66667 1.66667ZM4.16667 9.16667V15C4.16667 15.4602 4.53976 15.8333 5 15.8333H15C15.4602 15.8333 15.8333 15.4602 15.8333 15V9.16667H4.16667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }